<template>
  <div class="container">
    <div class="top_title"><router-link class="icon_back" to="H110010" tag="span"></router-link><p>点读课本</p></div>

    <div class="bookTop">
      <div class="bookTopImg"><img :src="info.I_ICON"></div>
      <div class="bookTop_contents">
        <p class="title1">{{info.I_TITLE_1}}</p>
        <span class="read_num">{{info.I_READ_NUM}}</span>
        <p class="title2">{{info.I_TITLE_2}}</p>
      </div>
    </div>

    <p class="title"><span></span><span>目录</span></p>
    <div class="books">
      <a v-for="item in info.dataList" class="book" :href="item.I_URL">
          <div class="bookImg"><img :src="item.I_UNIT_IMG" /></div>
          <p>{{item.I_UNIT_NAME}}</p>
      </a>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'

  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        info: {
          I_BOOK_NO_SYS: "",
        },
        tabFlag: false,
      }
    },
    components: {
      Footer
    },
    created() {
      this.info.I_TB_NO_SYS = this.$route.params.id
      if(this.info.I_TB_NO_SYS) {
        window.localStorage.setItem("H110020", this.info.I_TB_NO_SYS)
      } else {
        this.info.I_TB_NO_SYS = window.localStorage.getItem("H110020")
      }
      let params = {
        I_TB_NO_SYS: this.info.I_TB_NO_SYS
      }
      DataRequestFactory.I110020(params).then((response) => {
        this.info = response
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H110020.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H110020.vue